import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import TableRow from '@/components/BlogPage/PostsList/TableView/TableRow';
import { BlogPostDto } from '@/components/BlogPage/types';
interface Props {
  posts: BlogPostDto[];
}
const TableView: FC<Props> = t0 => {
  const $ = _c(4);
  const {
    posts
  } = t0;
  let t1;
  if ($[0] !== posts) {
    t1 = posts.map(_temp);
    $[0] = posts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div>{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default TableView;
function _temp(post) {
  return <TableRow key={post.id} post={post} className="post-item" data-flip-id={post.id} />;
}